//import Vue from 'vue'

import Registar from "../../services/index.js";

export default {
  state: {
    windowWidth: window.innerWidth,
    registarData: [],
    types: [],
    documents: [],
    keywords: [],
    editions: [],
    editionDatabases: {},
    foreignAuthors: [],
    typeFilter: [],
    scientificFields: [],
    selectedTypes: [],
    selectedType: null,
    noviRad: {
      naziv: "",
      nazivEng: "",
      godina: "",
      sazetak: "",
      sazetakEng: "",
    },
    tip: null,
    vrsta: null,
    novaVrsta: "",
    doi: "",
    datumIzlozbe: "",
    mjestoIzlozbe: "",
    datumObrane: "",
    godiste: "",
    issn: "",
    isbn: "",
    broj: "",
    mjesto_izdavanja: "",
    urednik: "",
    relevantnost: "",
    znanstvena_publikacija: "",
    znanstvenaPodrucja: [],
    znanstvenaPodrucja2: [],
    znanstvenaPodrucja3: [],
    files: null,
    links: [],
    odabranTipIzdanja: false,
    novoIzdanje: null,
    odabraneKljucneRijeci: [],
    jezici: [],
    osobe: [],
    zvanja: [],
    akademskiStupnjevi: [],
    uposlenici: [],
    osobeNext: "/osobe?page=1",
    newSelectedAutors: [],
    odabraniStudentAutori: [],
    odabraniUposleniciAutori: [],
    odabraniStraniAutori: [],
    snackbar: {
      state: false,
      color: "green",
      text: "Obavijest",
    },
    odabraniJezik: {},
    akademskoOsoblje: {},
    studenti: {},
    user: {},
    straniAutori: {},
    countries: {},
    publishers: {},
    allIzdavaci: {},
    allBaze: {},
    izdanja: {},
    tipoviIzdanja: {},
    kreiranoIzdanje: null,
    selectedPodrucja: [],
    prevodi: [],
    linkovi: [],
    tipId: null,
    vrstaId: null,
    izdanje: {
      baze: [],
      izdavaci: [],
    },
    izdanjaByTip: [],
    fileIds: [],
    odabraniRad: null,
    odabranoIzdanje: null,
    odabraniUposlenik: null,
    odabranaOsoba: null,
    odabraniStraniAutor: null,
    verificiran: false,
    showForm: false,
    dokumenti: [],
    bazaHints: null,
    izdanjaHints: null,
    izdavaciHints: null,
    jeziciHints: null,
    authorHints: null
  },
  getters: {
    getUser: state => state.user,
    hasAdminRights(state) {
      return (
        state.user.repo_user === "D"
      );
    },
    getDeviceType(state) {
      if (state.windowWidth < 1264) {
        return "touch";
      } else {
        return "desktop";
      }
    },
    getPhoneOrientation(state, getters) {
      if (
        getters.getDeviceType === "touch" &&
        window.innerWidth > window.innerHeight
      ) {
        return "landscape";
      } else if (
        getters.getDeviceType === "touch" &&
        window.innerWidth < window.innerHeight
      ) {
        return "portrait";
      }
    },
    getRegistarData(state) {
      return state.registarData;
    },
    getTypes(state) {
      return state.types;
    },
    getDocuments(state) {
      return state.documents;
    },
    getKeywords(state) {
      return state.keywords;
    },
    getEditions(state) {
      return state.editions;
    },
    getEditionDatabases(state) {
      return state.editionDatabases;
    },
    getForeignAuthors(state) {
      return state.foreignAuthors;
    },
    getTypesFilter(state) {
      return state.typeFilter;
    },
    getScientificFields(state) {
      return state.scientificFields;
    },
    getNoviRad(state) {
      return state.noviRad;
    },
    getTip(state) {
      return state.tip;
    },
    getVrsta(state) {
      return state.vrsta;
    },
    getNovaVrsta(state) {
      return state.novaVrsta;
    },
    getDoi(state) {
      return state.doi;
    },
    getDatumIzlozbe(state) {
      return state.datumIzlozbe;
    },
    getMjestoIzlozbe(state) {
      return state.mjestoIzlozbe;
    },
    getDatumObrane(state) {
      return state.datumObrane;
    },
    getGodiste(state) {
      return state.godiste;
    },
    getIssn(state) {
      return state.issn;
    },
    getIsbn(state) {
      return state.isbn;
    },
    getBroj(state) {
      return state.broj;
    },
    getMjesto_izdavanja(state) {
      return state.mjesto_izdavanja;
    },
    getUrednik(state) {
      return state.urednik;
    },
    getRelevantnost(state) {
      return state.relevantnost;
    },
    getZnanstvena_publikacija(state) {
      return state.znanstvena_publikacija;
    },
    getZnanstvenaPodrucja(state) {
      return state.znanstvenaPodrucja;
    },
    getZnanstvenaPodrucja2(state) {
      return state.znanstvenaPodrucja2;
    },
    getZnanstvenaPodrucja3(state) {
      return state.znanstvenaPodrucja3;
    },
    getFiles(state) {
      return state.files;
    },
    getLinks(state) {
      return state.links;
    },
    getOdabranTipIzdanja(state) {
      return state.odabranTipIzdanja;
    },
    getNovoIzdanje(state) {
      return state.novoIzdanje;
    },
    getOdabraneKljucneRijeci(state) {
      return state.odabraneKljucneRijeci;
    },
    getSvaZnanstvenaPodrucja(state, getters) {
      let svaPodrucja = []
      if (getters.getScientificFields) {
        getters.getScientificFields.forEach(podrucje => {
          svaPodrucja.push(podrucje)
          if (podrucje.children.length) {
            svaPodrucja = svaPodrucja.concat(podrucje.children)
            podrucje.children.forEach(child => {
              if (child.children.length) {
                svaPodrucja = svaPodrucja.concat(child.children)
              }
            })
          }
        })
      }
      return svaPodrucja
    },
    getJezici(state) {
      return state.jezici;
    },
    getOsobe(state) {
      return state.osobe;
    },
    getZvanja(state) {
      return state.zvanja;
    },
    getUposlenici(state) {
      return state.uposlenici;
    },
    getAkademskiStupnjevi(state) {
      return state.akademskiStupnjevi;
    },
    getosobeNext(state) {
      return state.osobeNext;
    },
    getNewSelectedAutors(state) {
      return state.newSelectedAutors;
    },
    getPotentialAutors(state) {
      return state.osobe.concat(state.uposlenici, state.foreignAuthors);
    },
    getOdabraniAutori(state) {
      return state.odabraniAutori;
    },
    snackbar(state) {
      return state.snackbar;
    },
    getOdabraniJezik(state) {
      return state.odabraniJezik;
    },
    getAllVrsteRada(state) {
      let vrsteRada = []
      state.typeFilter.forEach(type => {
        type.vrste_rada.forEach(vrsta => {
          vrsteRada.push(vrsta)
        })
        // vrsteRada.concat(type.vrste_rada)
      })
      return vrsteRada;
    },
    getAkademskoOsoblje: (state) => state.akademskoOsoblje,
    getStudenti: (state) => state.studenti,
    getStraniAutori: (state) => state.straniAutori,
    getCountries: (state) => state.countries,
    getPublishers: (state) => state.publishers,
    getAllIzdavaci: (state) => state.allIzdavaci,
    getAllBaze: (state) => state.allBaze,
    getIzdanja: (state) => state.izdanja,
    getTipoviIzdanja: (state) => state.tipoviIzdanja,
    getKreiranoIzdanje: (state) => state.kreiranoIzdanje,
    getSelectedPodrucja: (state) => state.selectedPodrucja,
    getOdabraniStudentAutori: (state) => state.odabraniStudentAutori,
    getOdabraniUposleniciAutori: (state) => state.odabraniUposleniciAutori,
    getOdabraniStraniAutori: (state) => state.odabraniStraniAutori,
    getPrevodi: (state) => state.prevodi,
    getLinkovi: state => state.linkovi,
    getTipRada(state, getters) {
      return getters.getTypesFilter.find(tip => tip.id == state.tipId)
    },
    getVrstaRada(state, getters) {
      return getters.getAllVrsteRada.find(vrsta => vrsta.id == state.vrstaId)
    },
    getIzdanjeBaze: state => state.izdanje.baze,
    getIzdanjeIzdavaci: state => state.izdanje.izdavaci,
    getIzdanjaByTip: state => state.izdanjaByTip,
    getFileIds: state => state.fileIds,
    getOdabraniRad: state => state.odabraniRad,
    getOdabranoIzdanje: state => state.odabranoIzdanje,
    getOdabraniUposlenik: state => state.odabraniUposlenik,
    getOdabranaOsoba: state => state.odabranaOsoba,
    getOdabraniStraniAutor: state => state.odabraniStraniAutor,
    getVerificiran: state => state.verificiran,
    getShowForm: state => state.showForm,
    getDokumenti: state => state.dokumenti,
    getBazaHints: state => state.bazaHints,
    getIzdanjaHints: state => state.izdanjaHints,
    getIzdavaciHints: state => state.izdavaciHints,
    getJeziciHints: state => state.jeziciHints,
    getAuthorHints: state => state.authorHints
  },
  mutations: {
    SET_WINDOW_WIDTH(state, width) {
      state.windowWidth = width;
    },
    SET_REGISTAR(state, data) {
      state.registarData = data;
    },
    SET_TYPES(state, data) {
      state.types = data;
    },
    SET_DOCUMENTS(state, data) {
      state.documents = data;
    },
    SET_KEYWORDS(state, data) {
      state.keywords = data;
    },
    SET_EDITIONS(state, data) {
      state.editions = data;
    },
    SET_EDITIONDATABASES(state, data) {
      state.editionDatabases = data;
    },
    SET_FOREIGNAUTHORS(state, data) {
      state.foreignAuthors = data;
    },
    SET_TYPES_FILTER(state, data) {
      state.typeFilter = data;
    },
    SET_SCIENTIFICFIELDS(state, data) {
      state.scientificFields = data;
    },
    SET_SELECTEDTYPES(state, data) {
      state.selectedTypes = data;
    },
    SET_RAD_NAZIV(state, data) {
      state.noviRad.naziv = data;
    },
    SET_RAD_NAZIV_ENG(state, data) {
      state.noviRad.nazivEng = data;
    },
    SET_RAD_GODINA(state, data) {
      state.noviRad.godina = data;
    },
    SET_RAD_SAZETAK(state, data) {
      state.noviRad.sazetak = data;
    },
    SET_RAD_SAZETAK_ENG(state, data) {
      state.noviRad.sazetakEng = data;
    },
    SET_TIP(state, data) {
      state.tip = data;
    },
    SET_TIP_BY_ID(state, data) {
      state.tip = state.typeFilter.find(t => t.id == data)
    },
    SET_VRSTA(state, data) {
      state.vrsta = data;
    },
    SET_NOVA_VRSTA(state, data) {
      state.novaVrsta = data;
    },
    SET_DOI(state, data) {
      state.doi = data;
    },
    SET_DATUM_IZLOZBE(state, data) {
      state.datumIzlozbe = data;
    },
    SET_MJESTO_IZLOZBE(state, data) {
      state.mjestoIzlozbe = data;
    },
    SET_DATUM_OBRANE(state, data) {
      state.datumObrane = data;
    },
    SET_GODISTE(state, data) {
      state.godiste = data;
    },
    SET_ISSN(state, data) {
      state.issn = data;
    },
    SET_ISBN(state, data) {
      state.isbn = data;
    },
    SET_BROJ(state, data) {
      state.broj = data;
    },
    SET_MJESTO_IZDAVANJA(state, data) {
      state.mjesto_izdavanja = data;
    },
    SET_UREDNIK(state, data) {
      state.urednik = data;
    },
    SET_REVEVANTNOST(state, data) {
      state.relevantnost = data;
    },
    SET_ZNANSTVENA_PUBLIKACIJA(state, data) {
      state.znanstvena_publikacija = data;
    },
    SET_ZNANSTVENA_PODRUCJA(state, data) {
      state.znanstvenaPodrucja = data;
    },
    SET_ZNANSTVENA_PODRUCJA2(state, data) {
      state.znanstvenaPodrucja2 = data;
    },
    SET_ZNANSTVENA_PODRUCJA3(state, data) {
      state.znanstvenaPodrucja3 = data;
    },
    SET_FILES(state, data) {
      state.files = data;
    },
    SET_LINKS(state, data) {
      state.linkovi.push(data);


    },
    REMOVE_LINK_AT_INDEX(state, index) {
      if (index >= 0) {
        state.links.splice(index, 1);
      }
    },
    SET_ODABRAN_TIP_IZDANJA(state, value) {
      state.odabranTipIzdanja = value;
    },
    SET_NOVO_IZDANJE(state, novoIzdanje) {
      state.novoIzdanje = novoIzdanje;
    },
    SET_ODABRANE_KLJUCNE_RIJECI(state, rijeci) {
      state.odabraneKljucneRijeci = rijeci;
    },
    SET_JEZICI(state, data) {
      state.jezici = data;
    },
    SET_JEZICI_HINTS(state, data) {
      state.jeziciHints = data
    },
    SET_UPOSLENICI(state, data) {
      state.uposlenici = data;
    },
    SET_OSOBE(state, data) {
      state.osobe = data;
    },
    SET_AKADEMSKI_STUPNJEVI(state, data) {
      state.akademskiStupnjevi = data;
    },
    SET_ZVANJA(state, data) {
      state.zvanja = data;
    },
    SET_NEXT_OSOBE_PAGE(state, osobeNext) {
      state.osobeNext = osobeNext;
    },
    ADD_AUTHORS(state, autor) {
      state.newSelectedAutors.push(autor);
    },
    // SET_ODABRANI_AUTORI(state, data) {
    //   state.odabraniAutori = data;
    // },
    SET_NOTIFICATION(state, notification) {
      state.snackbar.state = notification.state;
      state.snackbar.color = notification.color;
      state.snackbar.text = notification.text;
    },
    SET_ODABRANI_JEZIK(state, jezik) {
      state.odabraniJezik = jezik;
    },
    SET_AKADEMSKO_OSOBLJE(state, data) {
      state.akademskoOsoblje = data;
    },
    SET_STUDENTI(state, data) {
      state.studenti = data;
    },
    SET_USER(state, user) {
      state.user = user;
    },
    SET_STRANI_AUTORI(state, authors) {
      state.straniAutori = authors;
    },
    SET_COUNTRIES(state, countries) {
      state.countries = countries;
    },
    SET_PUBLISHERS(state, publishers) {
      state.publishers = publishers;
    },
    SET_ALL_IZDAVACI(state, allIzdavaci) {
      state.allIzdavaci = allIzdavaci;
    },
    SET_ALL_BAZE(state, allBaze) {
      state.allBaze = allBaze;
    },
    SET_IZDANJA(state, izdanja) {
      state.izdanja = izdanja;
    },
    SET_TIPOVI_IZDANJA(state, tipoviIzdanja) {
      state.tipoviIzdanja = tipoviIzdanja;
    },
    SET_KREIRANO_IZDANJE(state, izdanje) {
      state.kreiranoIzdanje = izdanje
    },
    SET_ODABRANI_AUTORI(state, autori) {
      autori.forEach(autor => {
        if (!state.odabraniAutori.includes(autor)) {
          Object.assign(autor, { redBr: state.odabraniStudentAutori.length + state.odabraniAutori.length + state.odabraniUposleniciAutori.length + 1 })
          state.odabraniAutori.push(autor)
        }
      })
    },
    SET_REMAINING_STUDENT_AUTHORS(state, authors) {
      state.odabraniStudentAutori = authors
    },
    SET_REMAINING_STRANI_AUTHORS(state, authors) {
      state.odabraniStraniAutori = authors
    },
    SET_REMAINING_UPOSLENICI_AUTHORS(state, authors) {
      state.odabraniUposleniciAutori = authors
    },
    SET_ODABRANI_STUDENT_AUTORI(state, autori) {
      autori.forEach(autor => {
        if (!state.odabraniStudentAutori.includes(autor)) {
          Object.assign(autor, { redBr: state.odabraniStudentAutori.length + state.odabraniStraniAutori.length + state.odabraniUposleniciAutori.length + 1, punoIme: autor.ime + " " + autor.prezime })
          state.odabraniStudentAutori.push(autor)
        }
      })
    },
    SET_ODABRANI_RAD(state, rad) {
      state.odabraniRad = rad;
    },
    SET_ODABRANO_IZDANJE(state, izdanje) {
      state.odabranoIzdanje = izdanje;
    },
    SET_ODABRANI_UPOSLENIK(state, uposlenik) {
      state.odabraniUposlenik = uposlenik;
    },
    SET_ODABRANA_OSOBA(state, osoba) {
      state.odabranaOsoba = osoba;
    },
    SET_ODABRANI_STRANI_AUTOR(state, osoba) {
      state.odabraniStraniAutor = osoba;
    },
    SET_ODABRANI_UPOSLENICI_AUTORI(state, autori) {
      autori.forEach(autor => {
        if (!state.odabraniUposleniciAutori.includes(autor)) {
          Object.assign(autor, { redBr: state.odabraniStudentAutori.length + state.odabraniStraniAutori.length + state.odabraniUposleniciAutori.length + 1, punoIme: autor.ime + " " + autor.prezime })
          state.odabraniUposleniciAutori.push(autor)
        }
      })
    },
    SET_ODABRANI_STRANI_AUTORI(state, autori) {
      autori.forEach(autor => {
        if (!state.odabraniStraniAutori.includes(autor)) {
          Object.assign(autor, { redBr: state.odabraniStudentAutori.length + state.odabraniStraniAutori.length + state.odabraniUposleniciAutori.length + 1, punoIme: autor.ime + " " + autor.prezime })
          state.odabraniStraniAutori.push(autor)
        }
      })
    },
    SET_SELECTED_PODRUCJA(state, selectedPodrucja) {
      state.selectedPodrucja = selectedPodrucja
    },
    SET_PREVOD(state, prevod) {
      state.prevodi.push(prevod)
    },
    SET_LINKOVI_RADA(state, data) {
      state.linkovi = data
    },
    SET_VRSTA_RADA(state, data) {
      state.tip = state.typeFilter.find(tip => tip.id == data.data[0].tip_id)
      let vrsteRada = []
      state.typeFilter.forEach(type => {
        type.vrste_rada.forEach(vrsta => {
          vrsteRada.push(vrsta)
        })
      })
      state.vrsta = vrsteRada.find(vrsta => vrsta.id == data.data[0].id)
    },
    SET_PREVODI(state, data) {
      state.prevodi = data
    },
    REMOVE_UPOSLENICI_AUTORI(state, data) {
      state.odabraniUposleniciAutori = data
    },
    REMOVE_STRANI_AUTORI(state, data) {
      state.odabraniStraniAutori = data
    },
    REMOVE_STUDENT_AUTORI(state, data) {
      state.odabraniStudentAutori = data
    },
    SET_IZDANJE_BAZE(state, data) {
      state.izdanje.baze = data
    },
    SET_IZDANJE_IZDAVACI(state, data) {
      state.izdanje.izdavaci = data
    },
    ADD_IZDANJE_IZDAVACI(state, data) {
      state.izdanje.izdavaci.push(data)
    },
    ADD_IZDANJE_BAZE(state, baza) {
      state.izdanje.baze.push(baza)
    },
    SET_KLJUCNE_RIJECI(state, data) {
      if (data.length) {
        data.forEach(kr => {
          if (!state.odabraneKljucneRijeci.includes(kr)) {
            state.odabraneKljucneRijeci.push(kr)
          }
        })
      }
      else {
        state.odabraneKljucneRijeci = data
      }
    },
    CHANGE_STUDENT_POREDAK(state, autor) {
      state.odabraniStudentAutori = state.odabraniStudentAutori.filter(e => {
        if (autor.id === e.id) {
          Object.assign(e, {redBr: null})
        }
        return e
      })
    },
    CHANGE_UPOSLENICI_POREDAK(state, autor) {
      state.odabraniUposleniciAutori = state.odabraniUposleniciAutori.filter(e => {
        if (autor.id === e.id) {
          Object.assign(e, {redBr: null})
        }
        return e
      })
    },
    CHANGE_STRANI_POREDAK(state, autor) {
      state.odabraniStraniAutori = state.odabraniStraniAutori.filter(e => {
        if (autor.id === e.id) {
          Object.assign(e, {redBr: null})
        }
        return e
      })
    },
    SET_IZDANJA_BY_TIP(state, izdanja) {
      state.izdanjaByTip = izdanja
    },
    ADD_FILE_ID(state, fileId) {
      state.fileIds.push(fileId.toString())
    },
    REMOVE_FILE_IDS(state) {
      state.fileIds = []
    },
    SET_VERIFICIRAN(state, data) {
      state.verificiran = data
    },
    SET_STUDENT_AUTORI_FROM_RAD(state, data) {
      if (data.length) {
        data.forEach(autor => {
          Object.assign(autor, { redBr: parseInt(autor.pivot.poredak) })
          Object.assign(autor, { punoIme: autor.ime +' '+autor.prezime})
          if (!state.odabraniStudentAutori.includes(autor)) {
            state.odabraniStudentAutori.push(autor)

          }
        })

      }
      else {
        state.odabraniStudentAutori = data

      }
    },
    SET_UPOSLENICI_AUTORI_FROM_RAD(state, data) {
      if (data.length) {
        data.forEach(autor => {
          Object.assign(autor, { redBr: parseInt(autor.pivot.poredak) })
          Object.assign(autor, { punoIme: autor.ime +' '+autor.prezime})
          if (!state.odabraniUposleniciAutori.includes(autor)) {
            state.odabraniUposleniciAutori.push(autor)

          }
        })

      }
      else {
        state.odabraniUposleniciAutori = data

      }
    },
    SET_STRANI_AUTORI_FROM_RAD(state, data) {
      if (data.length) {
        data.forEach(autor => {
          console.log(autor.pivot.poredak, 'redBr')
          Object.assign(autor, { redBr: parseInt(autor.pivot.poredak) })
          Object.assign(autor, { punoIme: autor.ime +' '+autor.prezime})
          if (!state.odabraniStraniAutori.includes(autor)) {
            state.odabraniStraniAutori.push(autor)

          }
        })

      }
      else {
        state.odabraniStraniAutori = data

      }
    },
    SET_SHOW_FORM(state, show) {
      state.showForm = show
    },
    REMOVE_FILE_ID(state, id) {
      state.fileIds = state.fileIds.filter(file => file.id != id)
    },
    SET_DOKUMENTI(state, data) {
      state.dokumenti = data
    },
    REMOVE_DOKUMENT(state, file) {
      state.dokumenti = state.dokumenti.filter(d => d.id != file.id)
    },
    ADD_TO_IZDANJA(state, izdanje) {
      state.allBaze.data = state.allBaze.data.push(izdanje)
    },
    ADD_TO_IZDAVACI(state, izdavac) {
      console.log(izdavac)
      // state.allIzdavaci.data = state.allIzdavaci.data.push(izdavac)
    },
    SET_BAZA_HINTS(state, bazaHints) {
      state.bazaHints = bazaHints
    },
    SET_IZDANJA_HINTS(state, izdanjaHints) {
      state.izdanjaHints = izdanjaHints
    },
    SET_IZDAVACI_HINTS(state, izdavaciHints) {
      state.izdavaciHints = izdavaciHints
    },
    SET_FOREIGN_AUTHOR_HINTS(state, authorHints){
      state.authorHints = authorHints
    }
  },
  actions: {
    setWindowWidth(context) {
      context.commit("SET_WINDOW_WIDTH", window.innerWidth);
    },
    async setDokumenti(context, data) {
      context.commit("SET_DOKUMENTI", data);
    },
    removeOldFile(context, file) {
      context.commit('REMOVE_DOKUMENT', file)
    },
    async getRegistar(context, params) {
      let data = await Registar.getRegistar(params);
      context.commit("SET_REGISTAR", data);
    },
    async getTypes(context) {
      let data = await Registar.getRegistarTypes();
      context.commit("SET_TYPES", data);
    },
    async getDocuments(context) {
      let data = await Registar.getRegistarDocuments();
      context.commit("SET_DOCUMENTS", data.data);
    },
    async getKeywords(context, search) {
      let data = await Registar.getRegistarKeywords(search);
      context.commit("SET_KEYWORDS", data.data);
    },
    async getEditions(context) {
      let data = await Registar.getRegistarEditions();
      context.commit("SET_EDITIONS", data.data);
    },
    async getEditionDatabases(context, page) {
      let data = await Registar.getRegistarEditionDatabases(page);
      context.commit("SET_EDITIONDATABASES", data);
    },
    async getForeignAuthors(context, search) {
      let data = await Registar.getRegistarForeignAuthors(search);
      data.data.forEach((osoba) => {
        Object.assign(osoba, { punoIme: osoba.ime + " " + osoba.prezime });
      });
      context.commit("SET_FOREIGNAUTHORS", data.data);
    },
    async getTypesFilter(context, search) {
      let data = await Registar.getRegistarTypesFilter(search);
      context.commit("SET_TYPES_FILTER", data.data);
    },
    async getScientificFields(context, search) {
      let data = await Registar.getScientificFields(search);
      context.commit("SET_SCIENTIFICFIELDS", data);
    },
    async createNewVrsta(context, params) {
      await Registar.createNewVrstaRada(params);
    },
    async setSelectedTypes(context, params) {
      context.commit("SET_SELECTEDTYPES", params);
    },
    async setNazivNoviRad(context, params) {
      context.commit("SET_RAD_NAZIV", params);
    },
    async setNazivEngNoviRad(context, params) {
      context.commit("SET_RAD_NAZIV_ENG", params);
    },
    async setGodinaNoviRad(context, params) {
      context.commit("SET_RAD_GODINA", params);
    },
    async setSazetakNoviRad(context, params) {
      context.commit("SET_RAD_SAZETAK", params);
    },
    async setSazetakEngNoviRad(context, params) {
      context.commit("SET_RAD_SAZETAK_ENG", params);
    },
    async setTip(context, params) {
      context.commit("SET_TIP", params);
    },
    async setVrsta(context, params) {
      context.commit("SET_VRSTA", params);
    },
    async setNovaVrsta(context, params) {
      context.commit("SET_NOVA_VRSTA", params);
    },
    async setDoi(context, params) {
      context.commit("SET_DOI", params);
    },
    async setDatumIzlozbe(context, params) {
      context.commit("SET_DATUM_IZLOZBE", params);
    },
    async setMjestoIzlozbe(context, params) {
      context.commit("SET_MJESTO_IZLOZBE", params);
    },
    async setDatumObrane(context, params) {
      context.commit("SET_DATUM_OBRANE", params);
    },
    async setGodiste(context, params) {
      context.commit("SET_GODISTE", params);
    },
    async setIssn(context, params) {
      context.commit("SET_ISSN", params);
    },
    async setIsbn(context, params) {
      context.commit("SET_ISBN", params);
    },
    async setBroj(context, params) {
      context.commit("SET_BROJ", params);
    },
    async setMjesto_izdavanja(context, params) {
      context.commit("SET_MJESTO_IZDAVANJA", params);
    },
    async setUrednik(context, params) {
      context.commit("SET_UREDNIK", params);
    },
    async setRelevantnost(context, params) {
      context.commit("SET_REVEVANTNOST", params);
    },
    async setZnanstvena_publikacija(context, params) {
      context.commit("SET_ZNANSTVENA_PUBLIKACIJA", params);
    },
    async setZnanstvenaPodrucja(context, params) {
      context.commit("SET_ZNANSTVENA_PODRUCJA", params);
    },
    async setZnanstvenaPodrucja2(context, params) {
      context.commit("SET_ZNANSTVENA_PODRUCJA2", params);
    },
    async setZnanstvenaPodrucja3(context, params) {
      context.commit("SET_ZNANSTVENA_PODRUCJA3", params);
    },
    async setFiles(context, params) {
      context.commit("SET_FILES", params);
    },
    async setLinks(context, params) {
      context.commit("SET_LINKS", params);
    },
    async removeLinkAtIndex(context, index) {
      context.commit("REMOVE_LINK_AT_INDEX", index);
    },
    async changeOdabranTipIzdanjaState(context, value) {
      context.commit("SET_ODABRAN_TIP_IZDANJA", value);
    },
    async addNovoIzdanje(context, novoIzdanje) {
      context.commit("SET_NOVO_IZDANJE", novoIzdanje);
    },
    async setOdabraneKljucneRijeci(context, rijeci) {
      let odabraneRijeci = []
      await rijeci.forEach((rijec) => {
        if (typeof rijec != "object") {
          Registar.createNewKljucnaRijec(rijec).then((res) => {
            if (!odabraneRijeci.includes(res)) {
              odabraneRijeci.push(res)
            }
          });
        } else {
          // if (!context.getters.getOdabraneKljucneRijeci.includes(rijec)) {
          if (!odabraneRijeci.includes(rijec)) {
            odabraneRijeci.push(rijec)
          }
          // }
        }
      });
      context.commit('SET_ODABRANE_KLJUCNE_RIJECI', odabraneRijeci)
    },
    async getOsobe(context, search) {
      let data = await Registar.getOsobe(search);
      // let res = []
      data.data.forEach((osoba) => {
        Object.assign(osoba, { punoIme: osoba.ime + " " + osoba.prezime });
      });
      context.commit("SET_NEXT_OSOBE_PAGE", data.next_page_url);
      context.commit("SET_OSOBE", data.data);
    },
    async getZvanja(context, search) {
      let data = await Registar.getZvanja(search);
      context.commit("SET_ZVANJA", data.data);
    },
    async getUposlenici(context, search) {
      let data = await Registar.getUposlenici(search);
      data.data.forEach((osoba) => {
        Object.assign(osoba, { punoIme: osoba.ime + " " + osoba.prezime });
      });
      context.commit("SET_UPOSLENICI", data.data);
    },
    async getJezici(context, search) {
      let data = await Registar.getJezici(search);
      context.commit("SET_JEZICI", data.data);
    },
    async getAkademskiStupnjevi(context, search) {
      let data = await Registar.getAkademskiStupnjevi(search);
      context.commit("SET_AKADEMSKI_STUPNJEVI", data.data);
    },
    async setNewAutor(context, autor) {
      context.commit("ADD_AUTHORS", autor);
    },
    async createNewStraniAutor(context, autor) {
      return await Registar.createNewStraniAutor(autor).then((res) => {
        context.dispatch("getStraniAutori", { page: 1, search: "" });
        return res;
      });
    },
    async editStraniAuthor(context, autor) {
      return await Registar.editStraniAuthor(autor).then((res) => {
        context.dispatch("getStraniAutori", { page: 1, search: "" });
        return res;
      });
    },
    async getOdabraniAutori(context, value) {
      context.commit("SET_ODABRANI_AUTORI", value);
    },
    getNotification(context, notification) {
      context.commit("SET_NOTIFICATION", notification);
    },
    setOdabraniJezik(context, jezik) {
      context.commit("SET_ODABRANI_JEZIK", jezik);
    },
    async kreirajNoviJezik(context, noviJezik) {
      return await Registar.kreirajNoviJezik(noviJezik).then((res) => {
        context.dispatch('getJezici')
        return res
      });
    },
    async getAkademskoOsoblje(context, params) {
      let data = await Registar.getAkademskoOsoblje(params);
      data.data.forEach((osoba) => {
        Object.assign(osoba, { punoIme: osoba.ime + " " + osoba.prezime });
      });
      context.commit("SET_AKADEMSKO_OSOBLJE", data);
    },
    async getStudenti(context, params) {
      let data = await Registar.getStudenti(params);
      data.data.forEach((osoba) => {
        Object.assign(osoba, { punoIme: osoba.ime + " " + osoba.prezime });
      });
      context.commit("SET_STUDENTI", data);
    },
    setUser(context, user) {
      context.commit("SET_USER", user);
    },
    async getStraniAutori(context, params) {
      let data = await Registar.getStraniAutori(params);
      data.data.forEach(autor => {
        Object.assign(autor, { punoIme: autor.ime + ' ' + autor.prezime })
      })
      context.commit("SET_STRANI_AUTORI", data);
    },
    async createNewDatabaseEdition(context, naziv) {
      return await Registar.createNewDatabaseEdition(naziv).then((res) => {
        context.dispatch("getEditionDatabases", { page: 1, search: "" });
        return res;
      });
    },
    async createAllNewDatabaseEdition(context, naziv) {
      return await Registar.createNewDatabaseEdition(naziv).then((res) => {
        context.dispatch("getAllBaze");
        return res;
      });
    },
    async editNewDatabaseEdition(context, edition) {
      return await Registar.editNewDatabaseEdition(edition).then((res) => {
        context.dispatch("getEditionDatabases", { page: 1, search: "" });
        return res;
      });
    },
    async getPublishers(context, params) {
      let data = await Registar.getIzdavaci(params);
      context.commit("SET_PUBLISHERS", data);
    },
    async getAllIzdavaci(context, params) {
      let data = await Registar.getAllIzdavaci(params);
      context.commit("SET_ALL_IZDAVACI", data);
    },
    async getAllBaze(context, params) {
      let data = await Registar.getAllBaze(params);
      context.commit("SET_ALL_BAZE", data);
    },
    async getCountries(context, params) {
      let data = await Registar.getCountries(params);
      context.commit("SET_COUNTRIES", data);
    },
    async createNewPublisher(context, publisher) {
      return await Registar.createNewPublisher(publisher).then((res) => {
        context.dispatch("getAllIzdavaci", { page: 1, search: "" });
        return res;
      });
    },

    async editPublisher(context, publisher) {
      return await Registar.editPublisher(publisher).then((res) => {
        context.dispatch("getPublishers", { page: 1, search: "" });
        return res;
      });
    },

    async deletePublisher(context, publisher) {
      return await Registar.deletePublisher(publisher).then((res) => {
        // context.dispatch("getPublishers", { page: 1, search: "" });
        return res;
      });
    },

    async deleteForeignAuthor(context, author) {
      return await Registar.deleteForeignAuthor(author).then((res) => {
        // context.dispatch("getStraniAutori", { page: 1, search: "" });
        return res;
      });
    },
    async deleteEditionDatabase(context, database) {
      return await Registar.deleteEditionDatabase(database).then((res) => {
        // context.dispatch("getEditionDatabases", { page: 1, search: "" });
        return res;
      });
    },
    async getIzdanja(context, params) {
      let data = await Registar.getIzdanja(params);
      context.commit("SET_IZDANJA", data);
    },
    async getTipoviIzdanja(context) {
      let data = await Registar.getTipoviIzdanja();
      context.commit("SET_TIPOVI_IZDANJA", data);
    },
    async getFiles(context) {
      let data = await Registar.getFileById();
      context.commit("SET_FILES", data);
    },
    async createNewIzdanje(context, izdanje) {
      return await Registar.createNewIzdanje(izdanje).then((res) => {
        context.dispatch("getIzdanja", { page: 1, search: "" });
        return res;
      });
    },
    async editIzdanje(context, publisher) {
      return await Registar.editIzdanje(publisher).then((res) => {
        context.dispatch("getIzdanja", { page: 1, search: "" });
        return res;
      });
    },
    async deleteIzdanje(context, publisher) {
      return await Registar.deleteIzdanje(publisher).then((res) => {
        // context.dispatch("getIzdanja", { page: 1, search: "" });
        return res;
      });
    },
    setKreiranoIzdanje(context, izdanje) {
      context.commit('SET_KREIRANO_IZDANJE', izdanje)
    },
    setSelectedStudenti(context, autori) {
      context.commit('SET_ODABRANI_STUDENT_AUTORI', autori)
    },
    setSelectedOsoblje(context, autori) {
      context.commit('SET_ODABRANI_UPOSLENICI_AUTORI', autori)
    },
    setSelectedStraniAutori(context, autori) {
      context.commit('SET_ODABRANI_STRANI_AUTORI', autori)
    },
    setSelectedPodrucja(context, podrucja) {
      context.commit('SET_SELECTED_PODRUCJA', podrucja)
    },
    async deleteLinkById(context, params) {
      return await Registar.urediLinkove(params.linkId).then((res) => {
        return res;
      });
    },
    async deletePrijevodById(context, params) {
      return await Registar.izbrisiOdabraniPrijevod(params.prijevodId).then((res) => {
        return res;
      });
    },
    async deleteDokumentById(context, params) {
      return await Registar.deleteDokument(params.dokumentId).then((res) => {
        return res;
      });
    },
    async createNewRad(context, rad) {
      let data = await Registar.createNewRad(rad)
      if (data) {
        context.commit('SET_KREIRANO_IZDANJE', [])
        context.commit('SET_ODABRANI_STUDENT_AUTORI', [])
        context.commit('SET_ODABRANI_UPOSLENICI_AUTORI', [])
        context.commit('SET_ODABRANI_STRANI_AUTORI', [])
        context.commit('SET_SELECTED_PODRUCJA', [])
        context.commit('SET_JEZICI', [])
        context.commit('SET_PREVODI', [])
        context.commit('SET_RAD_NAZIV', "")
        context.commit('SET_RAD_GODINA', "")
        context.commit('SET_RAD_SAZETAK', "")
        context.commit('SET_TIP', null)
        context.commit('SET_VRSTA', null)
        context.commit('SET_DOI', null)
        context.commit('SET_KLJUCNE_RIJECI', [])
        context.commit('SET_LINKOVI_RADA', [])
        context.commit('SET_FILES', [])
        context.commit('SET_DATUM_IZLOZBE', null)
        context.commit('SET_DATUM_OBRANE', null)
        context.commit('SET_GODISTE', null)
        context.commit('SET_MJESTO_IZLOZBE', null)
        context.commit('SET_VERIFICIRAN', false)
        context.commit('REMOVE_FILE_IDS')
        return data
      }
    },
    async verificirajRad(context, rad) {
      let data = await Registar.verificirajRad(rad)
      return data
    },
    async editRad(context, rad) {
      return await Registar.urediRad(rad).then(res => {
        context.commit('SET_KREIRANO_IZDANJE', [])
        context.commit('SET_ODABRANI_STUDENT_AUTORI', [])
        context.commit('SET_ODABRANI_UPOSLENICI_AUTORI', [])
        context.commit('SET_ODABRANI_STRANI_AUTORI', [])
        context.commit('SET_SELECTED_PODRUCJA', [])
        context.commit('SET_PREVODI', [])
        context.commit('SET_RAD_NAZIV', null)
        context.commit('SET_RAD_GODINA', null)
        context.commit('SET_RAD_SAZETAK', null)
        context.commit('SET_TIP', null)
        context.commit('SET_VRSTA', null)
        context.commit('SET_DOI', null)
        context.commit('SET_KLJUCNE_RIJECI', [])
        context.commit('SET_LINKOVI_RADA', [])
        context.commit('SET_FILES', [])
        context.commit('SET_DATUM_IZLOZBE', null)
        context.commit('SET_DATUM_OBRANE', null)
        context.commit('SET_GODISTE', null)
        context.commit('SET_MJESTO_IZLOZBE', null)
        context.commit('SET_VERIFICIRAN', false)
        context.commit('SET_FILES', null)
        context.commit('REMOVE_FILE_IDS')
        return res
      })
    },
    setPrevodi(context, prevod) {
      context.commit('SET_PREVOD', prevod)
    },
    async fetchRad(context, radId) {
      let data = await Registar.fetchRad(radId)
      context.commit('SET_ODABRANI_RAD', data)
    },
    async fetchIzdanje(context, izdanjeId) {
      let data = await Registar.fetchIzdanje(izdanjeId)
      context.commit('SET_ODABRANO_IZDANJE', data)
    },
    async fetchUposlenik(context, uposlenikId) {
      let data = await Registar.fetchUposlenik(uposlenikId)
      context.commit('SET_ODABRANI_UPOSLENIK', data)
    },
    async fetchOsoba(context, osobaId) {
      let data = await Registar.fetchOsoba(osobaId)
      context.commit('SET_ODABRANA_OSOBA', data)
    },
    async fetchStraniAutor(context, autorId) {
      let data = await Registar.fetchStraniAutor(autorId)
      context.commit('SET_ODABRANI_STRANI_AUTOR', data)
    },
    async fetchuposleniciAutori(context, radId) {
      let data = await Registar.fetchuposleniciAutori(radId)
      context.commit('SET_ODABRANI_UPOSLENICI_AUTORI', data.data)
    },
    async fetchstraniAutori(context, radId) {
      let data = await Registar.fetchstraniAutori(radId)
      context.commit('SET_ODABRANI_STRANI_AUTORI', data.data)
    },
    async fetchstudentiAutori(context, radId) {
      let data = await Registar.fetchstudentiAutori(radId)
      context.commit('SET_ODABRANI_STUDENT_AUTORI', data.data)
    },
    async fetchizdanje(context, radId) {
      let data = await Registar.fetchizdanje(radId)
      context.commit('SET_KREIRANO_IZDANJE', data.data[0])
    },
    async fetchlinkovi(context, radId) {
      let data = await Registar.fetchlinkovi(radId)
      context.commit('SET_LINKOVI_RADA', data.data)
    },
    async fetchdokumenti(context, radId) {
      let data = await Registar.fetchdokumenti(radId)
      context.commit('SET_FILES', data.data)
    },
    async fetchvrstaRada(context, radId) {
      let data = await Registar.fetchvrstaRada(radId)
      context.commit('SET_VRSTA_RADA', data)
    },
    async fetchznanstvenaPodrucja(context, radId) {
      let data = await Registar.fetchznanstvenaPodrucja(radId)
      context.commit('SET_SELECTED_PODRUCJA', data.data)
    },
    async fetchPrijevodi(context, radId) {
      let data = await Registar.fetchPrijevodi(radId)
      context.commit('SET_PREVODI', data.data)
    },
    async fetchKljucneRijeci(context, radId) {
      let data = await Registar.fetchKljucneRijeci(radId)
      context.commit('SET_KLJUCNE_RIJECI', data.data)
    },
    async deleteRad(context, radId) {
      return await Registar.deleteRad(radId).then((res) => {
        return res;
      });
    },
    async getIzdanjaBaze(context, izdanjeId) {
      let data = await Registar.getIzdanjaBaze(izdanjeId)
      context.commit('SET_IZDANJE_BAZE', data.data)
    },
    async getIzdanjaIzdavaci(context, izdanjeId) {
      let data = await Registar.getIzdanjaIzdavaci(izdanjeId)
      context.commit('SET_IZDANJE_IZDAVACI', data.data)
    },
    setIzdanjaBaze(context, baze) {
      context.commit('SET_IZDANJE_BAZE', baze)
    },
    addIzdanjaBaze(context, baze) {
      context.commit('ADD_IZDANJE_BAZE', baze)
    },
    setIzdanjaIzdavaci(context, izdavaci) {
      context.commit('SET_IZDANJE_IZDAVACI', izdavaci)
    },
    addIzdanjaIzdavaci(context, izdavaci) {
      context.commit('ADD_IZDANJE_IZDAVACI', izdavaci)
    },
    async detachIzdanjaBaze(context, params) {
      return await Registar.detachIzdanjaBaze(params)
    },
    async detachIzdanjaIzdavaci(context, params) {
      return await Registar.detachIzdanjaIzdavaci(params)
    },
    async detachuposleniciAutori(context, params) {
      return await Registar.detachuposleniciAutori(params)
    },
    async detachstraniAutori(context, params) {
      return await Registar.detachstraniAutori(params)
    },
    async detachstudentiAutori(context, params) {
      return await Registar.detachstudentiAutori(params)
    },
    async detachlinkovi(context, params) {
      // console.log(params)
      // if (params.ids.length) {
      return await Registar.detachlinkovi(params)
      // }
    },
    async detachdokumenti(context, params) {
      return await Registar.detachdokumenti(params)
    },
    async detachvrstaRada(context, params) {
      return await Registar.detachvrstaRada(params)
    },
    async detachizdanje(context, params) {
      return await Registar.detachizdanje(params)
    },
    async detachKljucneRijeci(context, params) {
      return await Registar.detachKljucneRijeci(params)
    },
    async detachznanstvenaPodrucja(context, params) {
      return await Registar.detachznanstvenaPodrucja(params)
    },
    async detachPrijevodi(context, params) {

      return await Registar.detachPrijevodi(params)

    },
    async setRadDetails(context, rad) {
      await context.commit('SET_RAD_NAZIV', rad.naslov)
      await context.commit('SET_RAD_GODINA', rad.godina)
      await context.commit('SET_RAD_SAZETAK', rad.sazetak)
      if (rad.doi) {
        await context.commit('SET_DOI', rad.doi)
      }
      if (rad.izdanje_id) {
        await context.commit('SET_KREIRANO_IZDANJE', rad.izdanje)
      }
      if (rad.vrsta_rada_id) {
        await context.commit('SET_TIP_BY_ID', rad.vrsta_rada.tip_id)
        await context.commit('SET_VRSTA', rad.vrsta_rada)
      }
      if (rad.dokumenti_rada.length) {
        await context.commit('SET_DOKUMENTI', rad.dokumenti_rada)
      }
      await context.commit('SET_LINKOVI_RADA', rad.linkovi)
      if (rad.znanstvena_podrucja.length) {
        await context.commit('SET_SELECTED_PODRUCJA', rad.znanstvena_podrucja)
      }
      await context.commit('SET_STUDENT_AUTORI_FROM_RAD', rad.studenti_autori)
      await context.commit('SET_UPOSLENICI_AUTORI_FROM_RAD', rad.uposlenici_autori)
      await context.commit('SET_STRANI_AUTORI_FROM_RAD', rad.strani_autori)
      await context.commit('SET_PREVODI', rad.prijevodi)
      await context.commit('SET_KLJUCNE_RIJECI', rad.kljucne_rijeci)
      await context.commit('SET_DATUM_IZLOZBE', rad.datum_izlozbe)
      await context.commit('SET_DATUM_OBRANE', rad.datum_obrane)
      await context.commit('SET_GODISTE', rad.godiste)
      await context.commit('SET_MJESTO_IZLOZBE', rad.mjesto_izlozbe)
      await context.commit('SET_VERIFICIRAN', rad.verificiran)
      return true
    },
    async removeSelectedData(context) {
      context.commit('SET_KREIRANO_IZDANJE', null)
      context.commit('SET_LINKOVI_RADA', null)
      context.commit('SET_FILES', null)
      context.commit('SET_TIP', null)
      context.commit('SET_VRSTA', null)
      context.commit('SET_SELECTED_PODRUCJA', [])
      context.commit('REMOVE_STUDENT_AUTORI', [])
      context.commit('REMOVE_UPOSLENICI_AUTORI', [])
      context.commit('REMOVE_STRANI_AUTORI', [])
      context.commit('SET_PREVODI', [])
      context.commit('SET_RAD_NAZIV', null)
      context.commit('SET_RAD_GODINA', null)
      context.commit('SET_RAD_SAZETAK', null)
      context.commit('SET_DOI', null)
      context.commit('SET_KLJUCNE_RIJECI', []),
        context.commit('REMOVE_FILE_IDS')
    },
    changeStudentPoredak(context, autor) {
      context.commit('CHANGE_STUDENT_POREDAK', autor)
    },
    changeUposleniciPoredak(context, autor) {
      context.commit('CHANGE_UPOSLENICI_POREDAK', autor)
    },
    changeStraniPoredak(context, autor) {
      context.commit('CHANGE_STRANI_POREDAK', autor)
    },
    getIzdanjaByTip(context, params) {
      return Registar.getIzdanjaByTip(params).then(res => {
        context.commit('SET_IZDANJA_BY_TIP', res.data)
      })
    },
    addFileId(context, id) {
      context.commit('ADD_FILE_ID', id)
    },
    clearFileIds(context) {
      context.commit('REMOVE_FILE_IDS')
    },
    logout() {
      Registar.logout()
    },
    async setShowForm(context, show) {
      context.commit('SET_SHOW_FORM', show)
    },
    removeFileById(context, id) {
      context.commit('REMOVE_FILE_ID', id)
    },
    async getBazaIzdanjaHint(context, params) {
      let data = await Registar.getRegistarEditionDatabases(params)
      context.commit('SET_BAZA_HINTS', data)
    },
    async getAuthorsHint(context, params) {
      let data = await Registar.getAuthorHints(params)
      context.commit('SET_FOREIGN_AUTHOR_HINTS', data)
    },
    async getIzdanjaHint(context, params) {
      let data = await Registar.getIzdanja(params)
      context.commit('SET_IZDANJA_HINTS', data)
    },
    async getIzdavacHint(context, params) {
      let data = await Registar.getIzdavaci(params);
      context.commit('SET_IZDAVACI_HINTS', data)
    },
    async getJeziciHint(context, search) {
      let data = await Registar.getJezici(search);
      context.commit('SET_JEZICI_HINTS', data)
    }
  },
};
